// One JSON call to this origin with the session's bearer (slice 05). Every
// caller reads the status and the body itself; a network failure is status 0.
// An expired token is refreshed and the call sent again (`authFetch`, issue 793).
import { authFetch } from './session';

export interface JsonAnswer {
  status: number;
  body: unknown;
}

export async function requestJson(path: string, init: RequestInit = {}, fetchImpl: typeof fetch = fetch): Promise<JsonAnswer> {
  try {
    const res = await authFetch(path, {
      ...init,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...((init.headers ?? {}) as Record<string, string>) },
    }, fetchImpl);
    const body: unknown = res.status === 204 ? null : await res.json().catch(() => null);
    return { status: res.status, body };
  } catch {
    return { status: 0, body: null };
  }
}
